export default {
	danger: '#e53935',
	green: '#43A047',
	yellow: '#e7b032',
	swal: '#394978',
	orange: '#FB8C00',
	blue: '#394978',
	orangeTable: '#FFCC80',
	greenTable: '#8BC34A',
	redTable: '#EF5350',
	blueTable: '#42A5F5',
	white: '#fff',
	black: '#000',
	new_blue: '#384f80',
	new_blue2: '#4865a3',
	new_blue3: '#28395d',
	new_green: '#89c43f',
	new_gray: '#666666',
	gray: '#d2d3d6',
	corporate: '#D900D9',
	blue_link: '#0000ff',
}